import React, { useContext } from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { useIntl } from 'react-intl';
import ProjectViewModal from './ProjectViewModal';
import { EventEmitter, getTranslatedText } from '@nile/components/src';
import { UPDATE_VIEW } from '@nile/graphql/src/Mutation/views';
import { GET_PROJECT_VIEW } from '../../Graphql/Query/projectview';
import { TicketContext } from '@nile/mangifera/src/Contexts';

const EditProjectView = (props) => {
  const { onClose, id, viewType } = props;

  const intl = useIntl();
  const context = useContext(TicketContext);

  const { data: projectView, loading } = useQuery(GET_PROJECT_VIEW, {
    variables: {
      id
    },
    fetchPolicy: 'network-only'
  });

  const [updateProjectView] = useMutation(UPDATE_VIEW);

  const updateProject = (input) => {
    return updateProjectView({
      variables: {
        id: projectView.getProjectView.id,
        input: input
      }
    }).then((res) => {
      EventEmitter.dispatch('refreshProjectViewCount');
      EventEmitter.dispatch('updateProjectView');
      // To Update the view name in Project Toolbar Component (Header)
      res?.data?.updateView && context.setActiveView(res?.data?.updateView);
    });
  };

  const actions = {
    primaryAction: updateProject,
    back: onClose
  };

  if (loading) return null;

  return (
    <ProjectViewModal
      isOpen
      title={getTranslatedText(intl, 'project.view.edit.header')}
      actions={actions}
      actionvalue={'edit'}
      projectViewName={projectView.getProjectView.name}
      isSharedChecked={projectView.getProjectView.shared}
      viewCondition={projectView.getProjectView.viewCondition}
      displayIcon={projectView.getProjectView.displayIcon}
      isProjectViewLoading={loading}
      viewType={viewType}
    />
  );
};

export default EditProjectView;
